import Vue from 'vue'
import Vuex from 'vuex'

// import button settings
import buttonsettings from './elementSettings/buttonsettings.js';

// import blocks settings
import blockssettings from './elementSettings/blockssettings.js';

// import vertical divider settings
import verticaldividersettings from './elementSettings/verticaldividersettings.js';

// import horizotnal divider settings
import horizontaldividersettings from './elementSettings/horizontaldividersettings.js';

// lightbox settings
import lightboxsettings from './elementSettings/lightboxsettings.js';

// accordion settings
import accordionsettings from './elementSettings/accordionsettings.js';

// anchorsettings
import anchorsettings from './elementSettings/anchorsettings.js';

// contentslider
import contentslidersettings from './elementSettings/contentslidersettings.js';

// testimonial slider
import testimonialslidersettings from './elementSettings/testimonialslidersettings.js';

// imageslider
import imageslidersettings from './elementSettings/imageslidersettings.js';

// animate on scroll
import animateonscrollsettings from './elementSettings/animateonscrollsettings.js';

// carousel
import contentslidercarouselsettings from './elementSettings/contentslidercarouselsettings.js';

// recent blog cards
import blogcardssettings from './elementSettings/blogcardssettings.js';

// recent blog cards slider
import blogcardsslidersettings from './elementSettings/blogcardsslidersettings.js';

// pricing table settings
import pricingtablesettings from './elementSettings/pricingtablesettings.js';

// title settings
import titlesettings from './elementSettings/titlesettings.js';


Vue.use(Vuex)

export const store = new Vuex.Store({

    state: {   
        jwtToken: '',
        // element id Weebly
        elementIdWeebly: null,
        // site id Weebly
        siteIdWeebly: null,
        // user id Weebly
        userIdWeebly: null,

        clientInfo: {
            // client Email
            clientEmail: '',

            // client Account
            clientAccount: '',

            // client Activation Code
            clientActivationCode: '',

            // sites amount allowed
            clientSitesAmountAllowed: '',

            // sites used on
            clientSitesUsedOn: ''
        },

        // general Weebly
        weeblySettings:{
            name: 'SelectElements',
            html: 'testhtml',
            settings: 'tetsset'
        },


        // button settings
        buttonsettings,

        // blocks settings
        blockssettings,

        // guide for pop settings positioning
        showBlockChildSettingsGuide: true,

        // guide for elements dashboard only
        elementGuidesOnlyDashboard: true,

        // vertical divider settings
        verticaldividersettings,

        // horizontal divider settings
        horizontaldividersettings,

        // lightbox settings
        lightboxsettings,

        // accordion settings
        accordionsettings,

        // anchor settings
        anchorsettings,

        // content slider settings
        contentslidersettings,

        // testimonial slider
        testimonialslidersettings,

        // animate on scroll settings
        animateonscrollsettings,

        // carousel settings
        contentslidercarouselsettings,

        // image slider settings
        imageslidersettings,

        // blogcards recent posts
        blogcardssettings,

        // blogcards recent posts slider
        blogcardsslidersettings,

        // pricingtables
        pricingtablesettings,

        // titles
        titlesettings,

        // elements states
        showSaveBtn: false,

        showBackToElements: false,
        
        // settings sidebar
        showSettingsBar: false,

        savingOverlay: false,

        //font categories
        fontCategories : {
            serif: true,
            sansserif: true,
            display: true,
            handwriting: true,
            monospace: true
        },

        disableAddMoreFontsBtn: false,

        // preview font family
        fontPreview: {
            fontFamilyPreview: 'Roboto',
            fontWeightPreview: '400',
            fontStylePreview: 'normal',
            fontFamilyGoogle: 'Roboto:400'
        },

        googleFontsToLoad: ["Roboto:400"],

        previewBoxWidth: '100%',

        deviceStyles: {
            desktopStyles: true,
            tabletStyles: false,
            mobileStyles: false
        }
        

    }

})


// WEBPACK FOOTER //
// ./src/store/store.js